import { render, staticRenderFns } from "./CtintMainTabLayoutContent.vue?vue&type=template&id=5f00bcb8&scoped=true&"
import script from "./CtintMainTabLayoutContent.vue?vue&type=script&lang=js&"
export * from "./CtintMainTabLayoutContent.vue?vue&type=script&lang=js&"
import style0 from "./CtintMainTabLayoutContent.vue?vue&type=style&index=0&id=5f00bcb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f00bcb8",
  null
  
)

export default component.exports